import { OctInputCellGroup } from "@oceantech/oceantech-ui";
import React, {ChangeEvent, FC, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import { Col, FormCheck, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import withBarcodeScan from "../../../../hoc/withBarcodeScan";
import useIndexDBValue from "../../../../hook/useIndexDBValue";
import { AppContext } from "../../../appContext/AppContext";
import AutocompleteObjectV2 from "../../../component/AutocompleteObjectV2";
import LabelRequired from "../../../component/LabelRequired";
import ModalTimKiemBenhNhan from "../../../component/modal-tim-kiem-benh-nhan/ModalTimKiemBenhNhan";
import TextField from "../../../component/TextField";
import { customFilterOption, getCategory, getSimpleCategory } from "../../../utils/AppFunction";
import {
  APP_CONFIGURATION_KEYS,
  CODE,
  DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
  ID_DANG_KY_KHAM,
  KEY,
  KEY_DS_DANH_MUC_TIEP_DON,
  RESPONSE_MESSAGE,
  SIMPLE_CATEGORY_TYPE,
  TERM_CLASS_IDS,
  UU_TIEN,
  VARIABLE_STRING
} from "../../../utils/Constant";
import { calculateAge, convertToStringWithDelimiter, formatDateTime, formatMoney } from "../../../utils/FormatUtils";
import {
  CODE_GIOI_TINH,
  DEFAULT_CODE_SELECT_TIEPDON, DEFAULT_OCCUPATION,
  KEY_SEARCH
} from "../../constants/constants";
import { CODE_DOI_TUONG } from "../../constants/PhanHeTiepNhan";
import useReadQRCode from "../../hooks/useReadQRCode";
import {IDanhSachDanhMuc, InsuranceVerifyParams, QRCccdValue} from "../../models/TiepDonModel";
import {PhanHeTiepNhanContext, usePhanHeTiepNhanContext} from "../../PhanHeTiepNhan";
import {getBenhNhan, getPatientId, updateVisitFields, verifyHealthInsurance} from "../../services/TiepNhanServices";
import { benhNhanProps } from "../../tab-tiep-nhan/TiepNhan";
import { InsuranceInfo } from "./health-insurance";
import ScanQRCccdButton from "./ScanQRCccdButton";
import {
  convertAdditionalForm,
  convertInsData, convertPatientDataFromIDQR,
  getDepartmentOpt, getOptionByCode,
  getProvinceById, getSubDistrictByProvinceId,
  getSubDistrictByShortName, isPatientChange
} from "../../util/FunctionUtil";
import {localStorageItem} from "../../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../../auth/core/_consts";
import {useFormikContext} from "formik";
import AdditionalInfo from "./additional-info/AdditionalInfo";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";

const TTHanhChinhV2: FC<benhNhanProps & {barcode?: string}> = React.memo(
  ({ values, errors, touched, setFieldValue, setValues, resetForm, barcode }) => {
    const {
      convertDataBenhNhan,
      patientRenewToggle,
      setOrderMain,
      thongTinBenhNhan,
      setThongTinBenhNhan,
    } = useContext<any>(PhanHeTiepNhanContext);
    const { setFormikState, setErrors, validateForm } = useFormikContext<any>();
    const {handleNewPatient = async () => {}} = usePhanHeTiepNhanContext();
    const {readCanCuocQRCode, readBHYTQRCode, getAddressInfo} = useReadQRCode();

    const insLookup = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INS_LOOKUP];

    const [isBHYT, setIsBHYT] = useState<boolean>(
      CODE_DOI_TUONG.BAO_HIEM === values?.visit?.visitObjectType?.code
    );
    const [objectSearch, setObjectSearch] = useState({
      phoneNumber: "",
      personName: "",
      soTheKCB: "",
      idNumber: "",
    });
    const regexNumber = /^\d*$/;

    const [openTimKiemBNDialog, setOpenTimKiemBNDialog] = useState(false);
    const [subDistricts, setSubDistricts] = useState<any[]>([]);
    const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
      key: KEY_DS_DANH_MUC_TIEP_DON,
    });
    const [patientId, setPatientId] = useState<string>();
    const { setIsLoading } = useContext(AppContext);
    const [patienAge, setPatienAge] = useState<any>(null);
    const [danhMucDichVuKhamBenh, setDanhMucDichVuKhamBenh] = useState<any[]>([]);
    const [listPolicyCode, setListPolicyCode] = useState<any[]>([]);
    const [isLookupBHYT, setIsLookupBHYT] = useState<boolean>(insLookup);

    const allowEdit = hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.TIEP_DON);

    const occupationRef = useRef<any>(null);
    const prevOccupationRef = useRef<any>(null);
    const provinceRef = useRef<any>(null);

    let patientValues = values?.patient,
      patientErrors = errors?.patient,
      patientTouched = touched?.patient;
    let visitValues = values?.visit,
      visitErrors = errors?.visit,
      visitTouched = touched?.visit;
    let personValues = patientValues?.person,
      personErrors = patientErrors?.person,
      personTouched = patientTouched?.person;
    let insuranceValues = values?.insurance;
    const isVisitStopped = visitValues?.stopped;

    const dateStartedManager = useTimeEditorManager({
      name: "dateStarted",
      values: visitValues,
      updateFields: updateVisitFields,
      onUpdateSuccess: (updatedData) => {
        handleChangeVisit("dateStarted", updatedData?.dateStarted);
      }
    });

    const handleGetListCategory= async () => {
      try {
        const dichVuKhamBenh = await getCategory(TERM_CLASS_IDS.KHAM_BENH);
        setDanhMucDichVuKhamBenh(dichVuKhamBenh);
      } catch (error) {
        console.error(error);
      }
    };

  useEffect(() => {
    const isInValid = personErrors?.dobDay || personErrors?.dobMonth || personErrors?.dobYear;
    if (isInValid) {
      setPatienAge(null);
      return;
    };
		setPatienAge(
      calculateAge(personValues?.dobDay, personValues?.dobMonth, personValues?.dobYear)
    );
	}, [
		personValues?.dobDay,
		personValues?.dobMonth,
		personValues?.dobYear,
		personErrors?.dobDay,
		personErrors?.dobMonth,
		personErrors?.dobYear,
	]);

    useEffect(() => {
      if (danhSachDanhMuc) {
        handleSetDefaultData(danhSachDanhMuc);
      }
    }, [danhSachDanhMuc]);

    useEffect(() => {
      handleGetListCategory().then(r => r);
      fetchPolicyCode().then(r => r);
    }, []);

    // Convert policyCode từ string sang object khi listPolicyCode đã load
    useEffect(() => {
      if (listPolicyCode?.length > 0 && visitValues?.policyCode) {
        const policyCode = visitValues.policyCode;
        // Nếu policyCode là string HOẶC là fallback object (name === code)
        const needsConversion = typeof policyCode === 'string' ||
          (typeof policyCode === 'object' && policyCode.code && policyCode.name === policyCode.code);

        if (needsConversion) {
          const codeToFind = typeof policyCode === 'string' ? policyCode : policyCode.code;
          const found = listPolicyCode.find((item: any) =>
            item?.code === codeToFind || item?.id === codeToFind
          );
          if (found && found.name !== policyCode.name) {
            // Chỉ update nếu tìm thấy object có name khác (tránh infinite loop)
            handleChangeVisit("policyCode", found);
          }
        }
      }
    }, [listPolicyCode, visitValues?.policyCode]);

    useEffect(() => {
      setIsBHYT(CODE_DOI_TUONG.BAO_HIEM === visitValues?.visitObjectType?.code);
    }, [visitValues?.visitObjectType]);

    useEffect(() => {
      if (patientId) {
        handleUpdateDataBenhNhan(patientId);
      }
    }, [patientId]);

    useEffect(() => {
      if (barcode) {
        searchBarcode(barcode);
      }
    }, [barcode]);

    const fetchPolicyCode = async () => {
      try {
        const response = await getSimpleCategory({
          type: SIMPLE_CATEGORY_TYPE.POLICY_CODE
        });
        if (response?.data?.code === CODE.SUCCESS) {
          setListPolicyCode(response.data.data.content || []);
        }
      } catch (error) {
        console.error("Error loading policy code:", error);
      }
    };

    const handleSetDefaultData = async (data: IDanhSachDanhMuc) => {
      const {QUOC_TICH_VN, GIOI_TINH, DAN_TOC_KINH} = DEFAULT_CODE_SELECT_TIEPDON;
      const {DOI_TUONG, VISIT, PATIENT} = VARIABLE_STRING;
      let listDKKham = data?.listDKKham;
      let listDanToc = data?.listDanToc;
      let listQuocTich = data?.listQuocTich;
      let listGioiTinh = data?.listGioiTinh;
      const defaultService = danhMucDichVuKhamBenh?.[0] || null;
      const dept = danhSachDanhMuc?.listPhongKham.find(
        (item: any) =>
          item?.code === defaultService?.attributes?.deptClinicCode ||
          item?.code === defaultService?.attributes?.deptLaboratoryCode
      );

      handleChangeValues((prevState) => {
        return ({
          [VISIT]: {
            ...prevState[VISIT],
            visitType: listDKKham?.find((item: any) => item?.id === ID_DANG_KY_KHAM.KHAM_BENH),
            [DOI_TUONG]: data?.listDoiTuong?.find((item) => item?.code === CODE_DOI_TUONG.YEU_CAU) || null,
            service: defaultService,
            dept,
          },
          [PATIENT]: {
            ...prevState[PATIENT],
            person: {
              ...prevState[PATIENT]?.person,
              ccountry: listQuocTich?.find((item: any) => item?.code === QUOC_TICH_VN),
              gender: listGioiTinh?.find((item: any) => item?.code === GIOI_TINH),
            },
            ethnicity: listDanToc?.find((item: any) => item?.code === DAN_TOC_KINH),
          },
        })
      })
    };
    
    const handleGetDoiTuongByCode = (code: string) => {
      return getOptionByCode(code, danhSachDanhMuc?.listDoiTuong || []);
    }

    const handleChangeTextSearch = (e: any) => {
      const { name, value } = e.target;
      if (name === KEY_SEARCH.SDT || name === KEY_SEARCH.CCCD) {
        if (regexNumber.test(value) || value === "") {
          setObjectSearch({ ...objectSearch, [name]: value });
        }
      } else {
        setObjectSearch({ ...objectSearch, [name]: value });
      }
    };

    const handleKeyDownShortName = (e: any) => {
      if (e.key === KEY.ENTER || e.key === KEY.TAB) {
        let hasShortName = danhSachDanhMuc?.subDistricts?.some(
            (item: any) => item?.shortName === e.target.value?.toUpperCase()
          );
        switch (e.key) {
          case KEY.ENTER:
            hasShortName ? occupationRef.current?.focus() : provinceRef.current?.focus();
            break;
          case KEY.TAB:
            hasShortName && prevOccupationRef.current?.focus();
            break;
          default:
            break;
        }
      }
    };

    const handleChangeValues = useCallback((
      values: Record<string, any> | ((prevState: Record<string, any>) => Record<string, any>),
      name?: string
    ) => {
      setFormikState((pre: any) => {
        let newValues: Record<string, any>;
        if (typeof values === "function") {
          newValues = values(pre.values) || {};
        } else if (name) {
          newValues = {
            [name]: {...pre.values?.[name], ...values},
          };
        } else {
          newValues = values;
        }
        validateForm({...pre.values, ...newValues}).then(r => r);
        return ({
          ...pre,
          values: {...pre.values, ...newValues},
        })
      });
    }, [])

    const updatePatient = (updates: Record<string, any>) => {
      handleChangeValues(updates, VARIABLE_STRING.PATIENT);
    };

    const updateVisit = (updates: Record<string, any>) => {
      handleChangeValues(updates, VARIABLE_STRING.VISIT);
    };

    const handleChangePatient = (name: string, value: any) => {
      switch (name) {
        case VARIABLE_STRING.TINH_HUYEN_XA: {
          const subDistrict = getSubDistrictByShortName(value || "", danhSachDanhMuc?.subDistricts || []) || null;
          if (subDistrict) {
            const province = getProvinceById(subDistrict?.provinceId || "", danhSachDanhMuc?.provinces || []);
            updatePatient({
              [name]: value,
              [VARIABLE_STRING.PROVINCE]: province,
              [VARIABLE_STRING.COMMUNE]: subDistrict,
            });
          } else {
            updatePatient({
              [name]: value,
              [VARIABLE_STRING.PROVINCE]: null,
              [VARIABLE_STRING.COMMUNE]: null,
            });
          }
          break;
        }
        case VARIABLE_STRING.PROVINCE: {
          const listSubdistrict = getSubDistrictByProvinceId(value?.id, danhSachDanhMuc?.subDistricts || [])
          setSubDistricts(listSubdistrict);
          updatePatient({
            [VARIABLE_STRING.PROVINCE]: value,
            [VARIABLE_STRING.DISTRICT]: null,
            [VARIABLE_STRING.COMMUNE]: null,
          });
          break;
        }
        case VARIABLE_STRING.DISTRICT:
          updatePatient({
            [VARIABLE_STRING.DISTRICT]: value,
            [VARIABLE_STRING.COMMUNE]: null,
          });
          break;
        case VARIABLE_STRING.COMMUNE:
          updatePatient({
            [name]: value,
            [VARIABLE_STRING.TINH_HUYEN_XA]: value?.shortName,
          });
          break;
        default:
          updatePatient({[name]: value,});
          break;
      }
    };

    const handleChangeVisit = (name: string, value: any) => {
      if (name === "service") {
        let deptObj = getDepartmentOpt(value, danhSachDanhMuc?.listPhongKham || []);
        updateVisit({[name]: value, dept: deptObj,});
      } else {
        updateVisit({[name]: value});
      }
    };

    const handleChangePersonInfo = (name: string, value: any) => {
      updatePatient({
        person: {...personValues, [name]: value},
      });
    };

    const handleChangeName = (name: string, value: any) => {
      const NAME_OF_MENS = "văn";
      const NAME_OF_WOMENS = "thị";
      let listText = value.trim().toLowerCase().split(/\s+/);
      let isMale = listText.includes(NAME_OF_MENS);
      let isFemale = listText.includes(NAME_OF_WOMENS);
      let gender = danhSachDanhMuc?.listGioiTinh?.find((item: any) => {
        if (isFemale) {
          return item?.code === CODE_GIOI_TINH.NU;
        }
        if (isMale) {
          return item?.code === CODE_GIOI_TINH.NAM;
        }
        return item?.code === DEFAULT_CODE_SELECT_TIEPDON.GIOI_TINH;
      });
      updatePatient({
        person: {
          ...personValues,
          ...(gender && { gender }),
          [name]: value.toUpperCase(),
        },
      });
    };

    const handleChangeInsurance = useCallback((name: string, value: any) => {
      handleChangeValues({[name]: value}, VARIABLE_STRING.INSURANCE)
    }, [handleChangeValues]);

    const handleSearchDsBenhNhan = (e: any) => {
      if (e.key === KEY.ENTER) {
        setPatientId("");
        setOpenTimKiemBNDialog(true);
      }
    };

    const handleSearchBenhNhan = async (e: any) => {
      const { name, value } = e.target;
      if (e.key === KEY.ENTER && value?.trim()) {
        resetForm?.();
        try {
          setIsLoading(true);
          let { data } = await getBenhNhan({
            [name]: value,
          });
          if (CODE.SUCCESS === data?.code) {
            await setPatientSearchData(data);
          } else {
            toast.warning("Xảy ra lỗi, vui lòng thử lại!");
          }
        } catch (error) {
          toast.warning("Xảy ra lỗi, vui lòng thử lại!");
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    const handleCloseModalTKBenhNhan = () => {
      setOpenTimKiemBNDialog(false);
      setObjectSearch({
        phoneNumber: "",
        personName: "",
        soTheKCB: "",
        idNumber: "",
      });
    };

    const handleUpdateDataBenhNhan = async (id: string) => {
      try {
        setIsLoading(true);
        const { data } = await getPatientId(id);
        if (CODE.SUCCESS === data?.code) {
          let dataConverted = convertDataBenhNhan({
            patient: data?.data || {},
            visit: {
              [VARIABLE_STRING.DOI_TUONG]: handleGetDoiTuongByCode(CODE_DOI_TUONG.YEU_CAU) || null,
              visitType: danhSachDanhMuc?.listDKKham.find(
                (item: any) => item?.id === ID_DANG_KY_KHAM.KHAM_BENH
              ),
            },
          }, listPolicyCode);
          setValues(dataConverted);
          setOrderMain(null);
          setThongTinBenhNhan({
            ...thongTinBenhNhan,
            isExamined: false,
            isMedicalExamSvcPaid: false,
          });
        } else {
          toast.warning("Xảy ra lỗi, vui lòng thử lại!");
        }
      } catch (error) {
        toast.warning("Xảy ra lỗi, vui lòng thử lại!");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    const setPatientSearchData = async (data: any) => {
      let isUpdate = patientValues?.id && visitValues?.id;
      let insData: any = {};
      let dataConverted = convertDataBenhNhan({
        ...(data?.data ?? {}),
        ...values,
        patient: data?.data ? data?.data : patientValues,
      }, listPolicyCode);
      console.log("dataConverted (patient existed): ", dataConverted);
      !isUpdate && setOrderMain(null);

      if (isLookupBHYT) {
        const person = dataConverted?.patient?.person;
        insData = await getVerifyInsuranceResult({
          maThe: dataConverted?.patient?.idNumber,
          hoTen: dataConverted?.patient?.personName,
          ngaySinh: [person?.dobDay, person?.dobMonth, person?.dobYear].join("/"),
        }) || {};
        console.log("Thông tin thông tuyến BHYT: ", insData);
      }

      const visitCode = (isLookupBHYT && (insuranceValues?.insCodeMaBhxh || insData?.maThe))
        ? CODE_DOI_TUONG.BAO_HIEM
        : CODE_DOI_TUONG.YEU_CAU;

      setFormikState((pre: any) => {
        return {
          ...pre,
          values: {
            ...pre.values,
            ...dataConverted,
            [VARIABLE_STRING.VISIT]: {
              ...pre.values.visit,
              [VARIABLE_STRING.DOI_TUONG]: handleGetDoiTuongByCode(visitCode) || null,
            },
            [VARIABLE_STRING.INSURANCE]: {...pre.values.insurance, ...(insData.maThe ? convertInsData(insData) : {})},
            ...(isUpdate && {
              encounter: values?.encounter,
            }),
          }
        }
      });
      setThongTinBenhNhan({
        ...thongTinBenhNhan,
        isExamined: false,
        isMedicalExamSvcPaid: false,
      });
    };

    const onReadCccdQRCode = useCallback(async (value: QRCccdValue) => {
      let insData: any = {};
      let additionalForm: any = {};
      try {
        setIsLoading(true);
        let isUpdate = Boolean(patientValues?.id && visitValues?.id);

        if (!isUpdate) {
          const { data } = await getBenhNhan({idNumber: value.soCccd,});

          if (CODE.SUCCESS === data.code && data.data) {
            await setPatientSearchData({
              data: {
                ...data.data,
                ...value,
                ...DEFAULT_OCCUPATION,
                person: {
                  id: data.data?.personId,
                }
              }
            });
            return;
          }
        }

        if (isLookupBHYT) {
          insData = await getVerifyInsuranceResult({
            maThe: value.soCccd,
            hoTen: value.hoTen,
            ngaySinh: [value.ngaySinh, value.thangSinh, value.namSinh].join('/'),
          }) || {};
          console.log("Thông tin thông tuyến BHYT: ", insData);
        }

        setFormikState((pre: any) => {
          const convertedPatientData = convertPatientDataFromIDQR(value, pre.values.patient);
          const insConvertedData = insData.maThe ? convertInsData(insData) : {};
          const visitCode = (isLookupBHYT && insData?.maThe)
            ? CODE_DOI_TUONG.BAO_HIEM
            : CODE_DOI_TUONG.YEU_CAU;

          if (value.hoTenBo || value.hoTenMe) {
            additionalForm = convertAdditionalForm({...pre.values, value});
          }

          return {
            ...pre,
            values: {
              ...pre.values,
              [VARIABLE_STRING.PATIENT]: convertedPatientData,
              [VARIABLE_STRING.INSURANCE]: {...pre.values.insurance, ...insConvertedData},
              [VARIABLE_STRING.ADDITIONAL_FORMS]: additionalForm,
              [VARIABLE_STRING.VISIT]: {
                ...pre.values.visit,
                visitObjectType: handleGetDoiTuongByCode(visitCode) || null,
              },
            }
          }
        })
      } catch (error) {
        console.error(error);
        toast.warning(RESPONSE_MESSAGE.ERROR);
      } finally {
        setIsLoading(false);
      }
    }, [
      isLookupBHYT,
      values,
      setPatientSearchData
    ]);

    const searchPatientByCode = useCallback(async (value: string) => {
       try {
         const {data} = await getBenhNhan({code: value});

         if (data.data) {
           await setPatientSearchData({
             data: {
                ...data.data,
                person: {
                  id: data.data?.personId,
                }
             }
           });
         }
       } catch (error) {
          console.error(error);
       }
    }, []);

    const onReadBHYTQRCode = useCallback(async (data: any, isLookedUp?: boolean) => {
      let insData: any = {};
      let lookupAddress: any = {};
      let address: any = {};

      if (isLookupBHYT && !isLookedUp) {
        insData = await getVerifyInsuranceResult({
          maThe: data.maSoBHYT,
          hoTen: data.hoTen,
          ngaySinh: `${data.ngaySinh}/${data.thangSinh}/${data.namSinh}`,
        }) || {};
        lookupAddress = await getAddressInfo(insData?.diaChi || "", true) || {};
        console.log("Thông tin thông tuyến BHYT: ", insData);
      }

      if (isPatientChange(patientValues, data)) {
        address = {
          province: lookupAddress?.provinceOption,
          commune: lookupAddress?.wardOption,
          address: lookupAddress?.town,
          administrativeUnit: lookupAddress?.wardOption?.shortName,
        }
      } else {
        address = {
          province: patientValues.province || data?.provinceOption || lookupAddress?.provinceOption,
          commune: patientValues.commune || data?.wardOption || lookupAddress?.wardOption,
          address: patientValues.address || data?.town || lookupAddress?.town,
          administrativeUnit: patientValues?.administrativeUnit
            || data?.wardOption?.shortName
            || lookupAddress?.administrativeUnit
            || lookupAddress?.wardOption?.shortName,
        }
      }

      setSubDistricts(getSubDistrictByProvinceId(address.province?.id || "", danhSachDanhMuc?.subDistricts || []));
      setFormikState((pre: any) => {
        console.log("Quét BHYT Value:", {
          ...pre.values.insurance,
          ...convertInsData({...(data?.maSoBHYT ? data : {}), ...(insData?.maThe ? insData : {})}),
        })
        return {
          ...pre,
          values: {
            ...pre.values,
            [VARIABLE_STRING.PATIENT]: {
              ...convertPatientDataFromIDQR(data, pre.values.patient),
              ...address,
            },
            [VARIABLE_STRING.VISIT]: {
              ...pre.values.visit,
              visitObjectType: handleGetDoiTuongByCode(CODE_DOI_TUONG.BAO_HIEM) || null
            },
            [VARIABLE_STRING.INSURANCE]: {
              ...pre.values.insurance,
              ...convertInsData({...data, ...(insData?.maThe ? insData : {})}),
            }
          }
        }
      });
    }, [
      danhSachDanhMuc?.listDoiTuong,
      insuranceValues,
      isLookupBHYT,
      patientValues,
      personValues,
      visitValues,
      insLookup,
    ]);

    const getVerifyInsuranceResult = async (params: InsuranceVerifyParams) => {
      const isMissingInfo = Object.values(params).some(i => !i);
      if (!insLookup || isMissingInfo) {return {};}
      try {
        setIsLoading(true);
        const { data, code } = await verifyHealthInsurance(params);

        if (data.ghiChu && isLookupBHYT && code === CODE.SUCCESS) {
          toast.info(data.ghiChu);
        }
        return data;
      } catch (error) {
        console.error(error);
        isLookupBHYT && toast.error(RESPONSE_MESSAGE.ERROR);
        return {};
      } finally {
        setIsLoading(false);
      }
    };

    const searchBarcode = useCallback(async (value: string) => {
      console.log('QR value:', value);
      const QR_SEPARATOR = '|';
      const QR_CCDD_SEPARATOR_COUNT = 7;
      const QR_CHILD_CCDD_SEPARATOR_COUNT = 11;
      const splittedValue = value.split(QR_SEPARATOR);
      console.log(splittedValue);

      if ([QR_CHILD_CCDD_SEPARATOR_COUNT, QR_CCDD_SEPARATOR_COUNT].includes(splittedValue.length)) {
        const data = await readCanCuocQRCode(value);
        setSubDistricts(data.listSubDistrictFiltered || [])
        console.log("QR data(CCCD): ", data);

        if (isPatientChange(patientValues, data) && handleNewPatient) {
          await handleNewPatient();
        }

        await onReadCccdQRCode(data);
        return;
      }

      if (splittedValue.length > QR_CHILD_CCDD_SEPARATOR_COUNT) {
        const data = await readBHYTQRCode(value) || {};
        console.log("QR data(BHYT): ", data);

        if (isPatientChange(patientValues, data) && handleNewPatient) {
          await handleNewPatient();
        }

        await onReadBHYTQRCode(data);
        return;
      }

      await searchPatientByCode(value);
    }, [onReadBHYTQRCode, onReadCccdQRCode, searchPatientByCode]);
    
    const getServiceOptionLabel = (option: any) => {
       return convertToStringWithDelimiter([
        option.code,
        option.name,
        option?.attributes ? `Giá: ${formatMoney(option.attributes?.svcFee || 0)}` : null
       ])
    };

    const insuranceBaseValues = useMemo(() => ({
      visit: {
        id: visitValues?.id,
        visitObjectType: visitValues?.visitObjectType,
        stopped: visitValues?.stopped,
        visitType: visitValues?.visitType,
      },
      patient: {
        id: patientValues?.id,
        person: personValues,
      },
      insurance: insuranceValues,
      appointmentId: values?.appointmentId,
      additionalForms: {
        tabGiayGioiThieu: {
          ggtHospital: {
            bvInsCode: values?.additionalForms?.tabGiayGioiThieu?.ggtHospital?.bvInsCode
          }
        }
      }
    }), [
      visitValues?.id,
      visitValues?.visitObjectType,
      visitValues?.stopped,
      visitValues?.visitType,
      patientValues?.id,
      personValues?.fullName,
      personValues?.idNumber,
      personValues?.dobDay,
      personValues?.dobMonth,
      personValues?.dobYear,
      insuranceValues,
      values?.appointmentId,
      values?.additionalForms?.tabGiayGioiThieu?.ggtHospital?.bvInsCode
    ]);

    const insuranceDisabled = useMemo(
      () => !isBHYT
        || isVisitStopped
        || thongTinBenhNhan?.isExamined
        || thongTinBenhNhan?.isMedicalExamSvcPaid,
      [isBHYT, isVisitStopped, thongTinBenhNhan?.isExamined, thongTinBenhNhan?.isMedicalExamSvcPaid]
    );

    return (
      <div className="d-flex">
        <div className="border border-left-0 border-top-0 py-2 spaces width-72 pe-2">
          <div>
            <div className="d-flex align-items-end">
              <div className="spaces width-25 position-relative">
                <TextField
                  label="Điện thoại"
                  name="phoneNumber"
                  labelClassName="min-w-90px color-blue-custom"
                  className=" min-w-130px ps-29px"
                  value={objectSearch?.phoneNumber}
                  onChange={handleChangeTextSearch}
                  onKeyDown={(e: any) => handleSearchDsBenhNhan(e)}
                />
                <div className="spaces width-4">
                  <h6 className="position-absolute muc-huong">
                    <i className="bi bi-search fs-4 color-blue-custom d-block spaces mt-5"></i>
                  </h6>
                </div>
              </div>

              <div className="spaces width-25 position-relative">
                <TextField
                  label="Họ và tên"
                  name="personName"
                  labelClassName="ps-2 min-w-90px color-blue-custom"
                  className=" ps-29px"
                  value={objectSearch?.personName}
                  onChange={handleChangeTextSearch}
                  onKeyDown={(e: any) => handleSearchDsBenhNhan(e)}
                />
                <div className="spaces width-4">
                  <h6 className="position-absolute muc-huong">
                    <i className="bi bi-search fs-4 color-blue-custom d-block spaces mt-5"></i>
                  </h6>
                </div>
              </div>

              <div className="spaces width-25 position-relative">
                <TextField
                  label="Căn cước"
                  name="idNumber"
                  labelClassName="ps-2 min-w-90px color-blue-custom"
                  className=" ps-29px"
                  value={objectSearch?.idNumber}
                  onChange={handleChangeTextSearch}
                  onKeyDown={(e: any) => handleSearchDsBenhNhan(e)}
                />
                <div className="spaces width-4">
                  <h6 className="position-absolute muc-huong">
                    <i className="bi bi-search fs-4 color-blue-custom d-block spaces mt-5"></i>
                  </h6>
                </div>
              </div>

              <div className="spaces width-25 d-flex flex-end">
                <FormCheck
                  type="checkbox"
                  label="Tra thông tuyến"
                  name=""
                  checked={isLookupBHYT}
                  onChange={(e) => {
                    setIsLookupBHYT(!isLookupBHYT);
                    setFieldValue(VARIABLE_STRING.INS_LOOKUP, isLookupBHYT);
                  }}
                  className="d-flex align-items-center me-2"
                  />
                <FormCheck
                  type="checkbox"
                  label="Ưu tiên"
                  name=""
                  checked={visitValues?.sortWeight === UU_TIEN.TRUE}
                  onChange={(e) =>
                    handleChangeVisit(
                      "sortWeight",
                      e.target.checked ? UU_TIEN.TRUE : UU_TIEN.FALSE
                    )
                  }
                  className="d-flex align-items-center me-2"
                  disabled={isVisitStopped}
                />
              </div>
            </div>
          </div>
          <Row className="spaces mx-0 mt-14">
            <Col xs="4" className="d-flex px-0 mb-3">
              <LabelRequired className="min-w-90px" label="Đối tượng" />
              <div className="d-flex flex-grow-1 gap-2">
                <div style={{ flex: 1 }}>
                  <AutocompleteObjectV2
                    options={danhSachDanhMuc?.listDoiTuong || []}
                    value={visitValues?.visitObjectType || null}
                    name="visitObjectType"
                    onChange={(selectedOption) =>
                      handleChangeVisit("visitObjectType", selectedOption)
                    }
                    touched={visitTouched?.visitObjectType}
                    errors={visitErrors?.visitObjectType}
                    isClearable={false}
                    isDisabled={isVisitStopped}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <AutocompleteObjectV2
                    options={listPolicyCode || []}
                    value={visitValues?.policyCode || null}
                    name="policyCode"
                    placeholder="Chi tiết"
                    onChange={(selectedOption) =>
                      handleChangeVisit("policyCode", selectedOption)
                    }
                    touched={visitTouched?.policyCode}
                    errors={visitErrors?.policyCode}
                    isClearable={true}
                    isDisabled={isVisitStopped}
                  />
                </div>
              </div>
            </Col>
            <Col xs="4" className="px-0 mb-3">
              <TextField
                label={
                  <div>
                    <span>Họ và tên</span>
                    <span className="text-danger"> (*)</span>
                  </div>
                }
                name="fullName"
                labelClassName="ps-2 min-w-90px"
                value={personValues?.fullName || ""}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const start = e.target.selectionStart;
                  const end = e.target.selectionEnd;
                  e.target.value = e.target.value.toUpperCase();
                  e.target.setSelectionRange(start, end);
                  handleChangeName(e.target.name, e.target.value);
                }}
                touched={personTouched?.fullName}
                errors={personErrors?.fullName}
                disabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3">
              <TextField
                label="Điện thoại"
                name="phoneNumber"
                labelClassName="ps-2 min-w-90px"
                value={personValues?.phoneNumber || ""}
                onChange={(e: any) =>
                  handleChangePersonInfo(e.target.name, e.target.value)
                }
                touched={personTouched?.phoneNumber}
                errors={personErrors?.phoneNumber}
                disabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3">
              <TextField
                className="min-w-130px"
                label="Mã BN"
                name="code"
                labelClassName="ms-0 min-w-90px"
                value={patientValues?.code || ""}
                onKeyDown={(e: any) => handleSearchBenhNhan(e)}
                onChange={(e: any) =>
                  handleChangePatient(e.target.name, e.target.value)
                }
                touched={patientTouched?.code}
                errors={patientErrors?.code}
                disabled={
                  isVisitStopped ||
                  thongTinBenhNhan?.isExamined ||
                  patientValues?.id
                }
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired
                label="Ngày sinh"
                isRequired
                className="ps-2 min-w-90px"
              />
              <div className="spaces ms-0 d-flex min-w-130px">
                <OctInputCellGroup
                  cells={[
                    {
                      name: 'dobDay',
                      length: 2,
                    },
                    {
                      name: 'dobMonth',
                      length: 2,
                    },
                    {
                      name: 'dobYear',
                      length: 4,
                    },
                  ]}
                  value={{
                    dobDay: personValues?.dobDay,
                    dobMonth: personValues?.dobMonth,
                    dobYear: personValues?.dobYear,
                  }}
                  onChange={(e) => {
                    handleChangePersonInfo(e.target.name, e.target.value);
                  }}
                  disabled={isVisitStopped}
                  errors={personErrors}
                  touched={personTouched}
                  inputClassName="customs-input"
						    />
                <div className="spaces width-5 d-flex flex-center fw-bold">
                  -
                </div>
                <div className="spaces width-35">
                  <TextField
                    name="dobYear"
                    type="text"
                    maxLength="4"
                    className="text-center"
                    disabled
                    value={patienAge ?? ""}
                  />
                </div>
              </div>
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <TextField
                className="min-w-130px no-spinners w-100"
                label="Căn cước"
                name="idNumber"
                labelClassName="ps-2 min-w-90px"
                value={personValues?.idNumber || ""}
                onKeyDown={(e: any) => handleSearchBenhNhan(e)}
                onChange={(e: any) =>
                  handleChangePersonInfo(
                    e.target.name,
                    e.target.value.toUpperCase()
                  )
                }
                touched={personTouched?.idNumber}
                errors={personErrors?.idNumber}
                disabled={isVisitStopped}
              />
              <ScanQRCccdButton onReadData={searchBarcode} disabled={isVisitStopped}/>
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired label="Giới tính" className="min-w-90px" />
              <AutocompleteObjectV2
                options={danhSachDanhMuc?.listGioiTinh || []}
                value={personValues?.gender}
                name="gender"
                onChange={(selectedOption) =>
                  handleChangePersonInfo("gender", selectedOption)
                }
                touched={personTouched?.gender}
                errors={personErrors?.gender}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired label="Quốc tịch" className="ps-2 min-w-90px" />
              <AutocompleteObjectV2
                options={danhSachDanhMuc?.listQuocTich || []}
                name="ccountry"
                value={personValues?.ccountry}
                valueField="code"
                onChange={(selectedOption) => {
                  handleChangePersonInfo("ccountry", selectedOption);
                }}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired label="Dân tộc" className="ps-2 min-w-90px" />
              <AutocompleteObjectV2
                options={danhSachDanhMuc?.listDanToc || []}
                value={patientValues?.ethnicity}
                name="ethnicity"
                onChange={(selectedOption) =>
                  handleChangePatient("ethnicity", selectedOption)
                }
                touched={patientTouched?.ethnicity}
                errors={patientErrors?.ethnicity}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3">
              <TextField
                className=" min-w-130px"
                label="SN/thôn/phố"
                name="address"
                value={patientValues?.address || ""}
                labelClassName="min-w-90px"
                onChange={(e: any) =>
                  handleChangePatient(e.target.name, e.target.value)
                }
                disabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3">
              <TextField
                className=" min-w-130px text-center"
                label="Tt/Hq/Xp"
                name="administrativeUnit"
                labelClassName="ps-2 min-w-90px"
                value={patientValues?.administrativeUnit || ""}
                onChange={(e: any) =>
                  handleChangePatient(e.target.name, e.target.value)
                }
                onKeyDown={handleKeyDownShortName}
                disabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired
                label="T/TP"
                className="ps-2 min-w-90px"
              />
              <AutocompleteObjectV2
                ref={provinceRef}
                options={danhSachDanhMuc?.provinces || []}
                value={patientValues?.province}
                name="province"
                onChange={(selectedOption) => {
                  handleChangePatient("province", selectedOption);
                }}
                touched={patientTouched?.province}
                errors={patientErrors?.province}
                placeholder="Tỉnh/Thành phố"
                filterOption={customFilterOption}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired label="X/P" className="min-w-90px" />
              <AutocompleteObjectV2
                ref={prevOccupationRef}
                options={patientValues?.province ? subDistricts : []}
                value={patientValues?.commune}
                name="commune"
                onChange={(selectedOption) => {
                  handleChangePatient("commune", selectedOption);
                }}
                touched={patientTouched?.commune}
                errors={patientErrors?.commune}
                dependencies={[
                  patientValues?.province,
                ]}
                placeholder="Xã/Phường"
                filterOption={customFilterOption}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired className="ps-2 min-w-90px" label="Nghề nghiệp" />
              <AutocompleteObjectV2
                ref={occupationRef}
                options={[]}
                searchFunction={getSimpleCategory}
                searchObject={{
                  pageIndex: DEFAULT_PAGE_INDEX,
                  pageSize: DEFAULT_PAGE_SIZE,
                  type: SIMPLE_CATEGORY_TYPE.NGHE_NGHIEP
                }}
                isSrcoll
                isSearchable
                labelSearch="keyword"
                value={patientValues?.occupation}
                name="occupation"
                valueField="id"
                onChange={(selectedOption) => {
                  handleChangePatient("occupation", selectedOption);
                }}
                touched={patientTouched?.occupation}
                errors={patientErrors?.occupation}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired className="ps-2 min-w-90px" label="ĐK khám" />
              <AutocompleteObjectV2
                options={danhSachDanhMuc?.listDKKham || []}
                value={visitValues?.visitType}
                name="visitType"
                onChange={(selectedOption) =>
                  handleChangeVisit("visitType", selectedOption)
                }
                touched={visitTouched?.visitType}
                errors={visitErrors?.visitType}
                isDisabled={isVisitStopped}
              />
            </Col>
            <Col xs="4" className="px-0 mb-3 d-flex">
              <LabelRequired
                className=" min-w-90px"
                label="Lúc"
              />
              {allowEdit && visitValues?.id ? (
                <TimeEditor
                  name="dateStarted"
                  values={visitValues}
                  isEditingTime={dateStartedManager.isEditingTime}
                  editedTime={dateStartedManager.editedTime}
                  showValidationConfirm={dateStartedManager.showValidationConfirm}
                  validationMessage={dateStartedManager.validationMessage}
                  onEdit={dateStartedManager.handleEditTime}
                  onCancel={dateStartedManager.handleCancelEdit}
                  onSave={dateStartedManager.handleSaveTime}
                  onConfirmValidation={dateStartedManager.handleConfirmValidation}
                  onCancelValidation={dateStartedManager.handleCancelValidation}
                  onTimeChange={dateStartedManager.setEditedTime}
                  viewInputType
                />
              ) : (
                <TextField
                  className="w-100"
                    name="dateStarted"
                  value={formatDateTime(visitValues?.dateStarted ?? new Date())}
                  disabled
                />
              )}
            </Col>
            <Col xs="8" className="px-0 mb-3 d-flex">
              <TextField
                label="Lý do khám"
                name="visitReason"
                labelClassName="ps-2 min-w-90px"
                className="w-100"
                value={visitValues?.visitReason || ""}
                onChange={(e: any) =>
                  handleChangeVisit(e.target.name, e.target.value)
                }
                touched={visitTouched?.visitReason}
                errors={visitErrors?.visitReason}
                disabled={isVisitStopped}
              />
            </Col>
            <Col xs="6" className="px-0 mb-3 d-flex">
              <LabelRequired
                className=" min-w-90px"
                label="Dịch vụ"
              />
              <AutocompleteObjectV2
                options={danhSachDanhMuc?.listDichVu || []}
                value={visitValues?.service || null}
                name="service"
                onChange={(selectedOption) => {
                  if (!selectedOption) {
                    setErrors({
                      ...errors,
                      visit: {
                        ...errors?.visit,
                        dept: "",
                      }
                    })
                  };
                  handleChangeVisit("service", selectedOption);
                }}
                getOptionLabel={getServiceOptionLabel}
                touched={visitTouched?.service}
                errors={visitErrors?.service}
                isDisabled={
                  isVisitStopped ||
                  thongTinBenhNhan?.isExamined ||
                  thongTinBenhNhan?.isMedicalExamSvcPaid
                }
              />
            </Col>
            <Col xs="6" className="px-0 mb-3 d-flex">
              <LabelRequired
                className="ps-2 min-w-125px"
                label="Phòng khám"
                isRequired={!!visitValues?.service}
              />
              <AutocompleteObjectV2
                options={danhSachDanhMuc?.listPhongKham || []}
                value={visitValues?.dept || null}
                name="dept"
                onChange={(selectedOption) => {
                  handleChangeVisit("dept", selectedOption);
                }}
                touched={visitTouched?.dept}
                errors={visitErrors?.dept}
                urlData={"data.data"}
                isDisabled={
                  isVisitStopped ||
                  thongTinBenhNhan?.isExamined ||
                  thongTinBenhNhan?.isMedicalExamSvcPaid
                }
              />
            </Col>
          </Row>
          <Row>
            <AdditionalInfo isView={isVisitStopped} />
          </Row>
        </div>

        <div className="border border-right-0 border-top-0 py-2 spaces width-28">
          <InsuranceInfo 
            isDisabled={insuranceDisabled}
            isBHYT={isBHYT}
            danhSachDanhMuc={danhSachDanhMuc}
            handleChangeInsurance={handleChangeInsurance}
            onReadBHYTQRCode={onReadBHYTQRCode}
            searchBarcode={searchBarcode}
            baseValues={insuranceBaseValues}
            setBaseValues={handleChangeValues}
          />
        </div>

        {openTimKiemBNDialog && (
          <ModalTimKiemBenhNhan
            open={openTimKiemBNDialog}
            handleClose={handleCloseModalTKBenhNhan}
            objectSearchBN={objectSearch}
            setPatientSelectedId={(id: string) => setPatientId(id)}
          />
        )}
      </div>
    );
  }
);
export default withBarcodeScan(TTHanhChinhV2);
